var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionSignOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3408 17.3922C17.7911 17.942 16.9556 17.1067 17.5055 16.557L20.4835 13.579H8.01059C7.23282 13.579 7.23282 12.3976 8.01059 12.3976H20.4835L17.5055 9.4197C16.9558 8.86993 17.7911 8.03444 18.3408 8.58443L22.3377 12.5815C22.5541 12.8053 22.5577 13.1723 22.327 13.4059L18.3408 17.3922ZM10.3971 3H5.08457C3.66172 3 2.5 4.16173 2.5 5.58479V20.3919C2.5 21.8147 3.66195 22.9764 5.08457 22.9764H10.3974C11.1751 22.9764 11.1751 21.795 10.3974 21.795H5.08457C4.31396 21.795 3.68119 21.1623 3.68119 20.3916V5.58479C3.68119 4.81419 4.31396 4.18142 5.08457 4.18142H10.3974C11.1749 4.18142 11.1749 3 10.3971 3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionSignOut);
export default __webpack_public_path__ + "static/media/action-sign-out.bc64273e80bf9191325000e92da64bfd.svg";
export { ForwardRef as ReactComponent };